export default __webpack_public_path__ + "static/media/1032.d2b41d6d.png";